import { render } from "./SegundoPost.vue?vue&type=template&id=443d115a"
import script from "./SegundoPost.vue?vue&type=script&lang=js"
export * from "./SegundoPost.vue?vue&type=script&lang=js"

import "../../assets/styles/post.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__